/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if(window.location.pathname.includes('thank-you-for-registering') || window.location.pathname.includes('registrazione-avvenuta')) {
    const p = document.createElement("p");
    p.innerText = window.languages.thankYouForRegistering;
    const user_type = window.localStorage.getItem("user_type");
    const welcome_section = document.querySelector('#user_type_thank_you');

    if(user_type && user_type !== 'end-user-private') {
        welcome_section.appendChild(p);
    }
}

if(window.location.pathname.includes('/login')) {
    const redirect_link = document.querySelector('#redirect_url');
    const redirectUrl =  window.localStorage.getItem("previousUrl");
    if(redirectUrl != '') {
      redirect_link.value = redirectUrl;
    }
}

//save the previous page url on every page visit, unless the current page is /account or /login 
//make an array of the urls to exclude
const excluded_urls = ['/account/register', '/account/login', '/challenge', '/challenge/submit', '/register'];

if(!excluded_urls.includes(window.location.pathname)) {
    window.localStorage.setItem("previousUrl", window.location.pathname);
}
